import { SVGProps } from 'react';

interface SparkleIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Sparkle Icon
 *
 * Represents AI-powered quizzes and intelligent features.
 * Star/sparkle design suggesting magic/AI capabilities.
 */
export function SparkleIcon({ size = 24, ...props }: SparkleIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 2L14.4 8.6L21 9.2L16 13.9L17.5 21L12 17.5L6.5 21L8 13.9L3 9.2L9.6 8.6L12 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 3L5.5 5L7 5.2L5.8 6.3L6.2 8L5 7L3.8 8L4.2 6.3L3 5.2L4.5 5L5 3Z"
        fill="currentColor"
      />
      <path
        d="M19 14L19.4 15.5L21 15.7L19.9 16.7L20.2 18.2L19 17.5L17.8 18.2L18.1 16.7L17 15.7L18.6 15.5L19 14Z"
        fill="currentColor"
      />
    </svg>
  );
}
